import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-download-icon',
  imports: [],
  templateUrl: './download-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './download-icon.component.scss',
})
export class DownloadIconComponent {}
